var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21V17.281C2.70513 17.2149 3.39423 16.9339 4.06731 16.438C4.74038 15.9091 5.28526 15.2314 5.70192 14.405C6.15064 13.5455 6.375 12.6364 6.375 11.6777H2V3H10.9423V10.6364C10.9423 12.8182 10.5256 14.6694 9.69231 16.1901C8.85897 17.6777 7.7532 18.8182 6.375 19.6116C5.02885 20.405 3.57051 20.8678 2 21ZM13.0577 21V17.281C13.7628 17.2149 14.4519 16.9339 15.125 16.438C15.7981 15.9091 16.3429 15.2314 16.7596 14.405C17.2083 13.5455 17.4327 12.6364 17.4327 11.6777H13.0577V3H22V10.6364C22 12.8182 21.5833 14.6694 20.75 16.1901C19.9167 17.6777 18.8109 18.8182 17.4327 19.6116C16.0865 20.405 14.6282 20.8678 13.0577 21Z",
    fill: "#020617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotes);
export default __webpack_public_path__ + "static/media/icon-quotes.056816454239ee15e71d6e06a49d4f91.svg";
export { ForwardRef as ReactComponent };